import { connect } from "react-redux";
import EmployeeTicketList from "./employeeTicketList";
import { bindActionCreators } from "redux";
import { fetchEmTicket, getEmployeeFilterDropDown } from "services/redux/maintenance/employeeTickets/action";
const mapStateToProps = (state) => ({
  employeeTicket: state.employeeTicketReducer.employeeTicket,
  employeeFilterList: state.employeeTicketReducer.employeeFilterList
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchEmTicket,
      getEmployeeFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeTicketList);
